import Vue from "vue"
import "./view/pages/quality/quality.css"
import App from "./App.vue"
import router from "./router"
import store from "@/core/services/store"
import ApiService from "@/core/services/api.service"
// import MockService from "@/core/mock/mock.service"
// import { VERIFY_AUTH } from "@/core/services/store/auth.module"
// import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module"

// print
import VueHtmlToPaper from 'vue-html-to-paper';

// print excel
import VueExcelXlsx from "vue-excel-xlsx";
import PageHeader from "@/component/general/PageHeader.vue";
import MedhopDataTable from "@/component/common/MedhopDataTable.vue";
import MedhopPagination from "@/component/common/MedhopPagination.vue";
import ClinicalFileUpload from "@/component/general/ClinicalFileUpload.vue";
import installFormFieldIcons from "@/core/plugins/form-field-icons";
import {
  applyClinicTimezone,
  clinicNowInput,
  clinicTimezone,
  formatClinicDate,
  formatClinicDateTime,
  formatClinicTime,
} from "@/core/services/clinic-time.service";

applyClinicTimezone();
Vue.prototype.$clinicTimezone = clinicTimezone;
Vue.prototype.$clinicNowInput = clinicNowInput;
Vue.prototype.$clinicDate = formatClinicDate;
Vue.prototype.$clinicDateTime = formatClinicDateTime;
Vue.prototype.$clinicTime = formatClinicTime;
Vue.filter("clinicDate", formatClinicDate);
Vue.filter("clinicDateTime", formatClinicDateTime);
Vue.filter("clinicTime", formatClinicTime);

Vue.use(VueExcelXlsx);
Vue.component("PageHeader", PageHeader);
Vue.component("medhop-data-table", MedhopDataTable);
Vue.component("medhop-pagination", MedhopPagination);
Vue.component("clinical-file-upload", ClinicalFileUpload);

// draw
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

const options = {
  name: 'cetak',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ]
}

Vue.use(VueHtmlToPaper, options);

// text editor
import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use(CKEditor);

import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce)

import ModernFilterBar from "@/component/general/ModernFilterBar.vue"
Vue.component("modern-filter-bar", ModernFilterBar)

import ModernSearchInput from "@/component/general/ModernSearchInput.vue"
Vue.component("modern-search-input", ModernSearchInput)

Vue.config.productionTip = false

// Global 3rd party plugins
import "popper.js"
import "tooltip.js"
import PerfectScrollbar from "perfect-scrollbar"
window.PerfectScrollbar = PerfectScrollbar
import ClipboardJS from "clipboard"
window.ClipboardJS = ClipboardJS

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n"
import vuetify from "@/core/plugins/vuetify"
import Swal from 'sweetalert2'
import "@/core/plugins/portal-vue"
import "@/core/plugins/bootstrap-vue"
import "@/core/plugins/perfect-scrollbar"
import "@/core/plugins/highlight-js"
import "@/core/plugins/inline-svg"
import "@/core/plugins/apexcharts"
import "@/core/plugins/treeselect"
import "@/core/plugins/metronic"
import "@mdi/font/css/materialdesignicons.css"
import "@/core/plugins/formvalidation"
import "moment"

import '@/assets/css/main.css'
import '@/assets/sass/pages/_enterprise-list-pages.scss'
import '@/assets/sass/pages/_payment-pages.scss'
import '@/assets/sass/pages/_service-payment-pages.scss'
import '@/assets/sass/pages/_doctor-bank-pages.scss'
import '@/assets/sass/pages/_clinical-polish.scss'
import '@/assets/sass/pages/_specialist-workspace.scss'
import '@/assets/sass/pages/_table-action-buttons.scss'
import '@/assets/sass/components/_medhop-tabs.scss'
import '@/assets/sass/_form-field-icons.scss'

// ckeditor

// API service init
ApiService.init()

// Remove this to disable mock API
// MockService.init()

// SweetAlert
window.Swal = Swal
window.SwalLoading = Swal.mixin({
  title: 'Loading',
  text: 'Sedang memproses data',
  icon: 'info',
  allowOutsideClick: false,
  allowEscapeKey: false,
  showConfirmButton: false,
  heightAuto: false,
  willOpen: () => {
    Swal.showLoading()
  }
})

window.s3Endpoint = `https://is3.cloudhost.id/medhop-prod-bucket`

router.beforeEach((to, from, next) => {

  document.title = to.meta.title

  let userD = null
  try {
    userD = JSON.parse(localStorage.getItem('user'))
  } catch (e) {}

  if (userD && userD.must_change_password) {
    if (to.name !== 'profile-change-password' && to.path !== '/profile/change-password' && to.name !== 'login' && to.path !== '/login') {
      return next({ name: 'profile-change-password' });
    }
  }

  let strg = null
  try {
    strg = JSON.parse(localStorage.getItem('tenantconfig'))
  } catch (e) {}

  if (userD != null && strg != null) {
    let subs_end = strg.end_date
    let current_date = window.medhopToday()
    if (subs_end < current_date) {
      let url = window.location.href
      url = url.split('/')

      // if (from.path != "/" && to.path != "/login" && url[url.length - 1] != "package" && url[url.length - 1] != "checkout" && url[url.length - 1] != "payment" && url[url.length - 2]+"/"+url[url.length - 1] != "billings/list") {
      if (to.path != "/login" && to.path != "/subscribe/package" && to.path != "/subscribe/checkout" && to.path != "/subscribe/payment" && to.path != "/billings/list" && to.path != "/subscribe-confirmation") {
        Swal.fire({
          icon: 'warning',
          title: 'Perhatian',
          text: 'Masa aktif anda telah habis, silahkan lakukan perpanjangan',
          timerProgressBar: true,
          timer: 5000,
          showConfirmButton: false,

        }).then(() => {
          router.push({
            path: '/subscribe/package',

          })
            .catch(() => true);
        })
      }
    }
  }


  // Ensure we checked auth before each page load.
  // Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // reset config to initial state
  // store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  //   setTimeout(() => {
  //     window.scrollTo(0, 0);
  //   }, 100);
  next();
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app")

installFormFieldIcons()
